var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-loading-dialog',{attrs:{"loading":_vm.$apollo.loading}},[_c('div',{staticClass:"whatsapp-home"},[_c('v-row',[_c('triggers-activity-chart')],1),_c('v-row',[_c('triggers-queue-chart')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }